module.exports = __webpack_public_path__ + "img/aiAssistanceBackground.bddc7348.png";